import { FALLBACK_LOCALE, LOCALES, type Locale } from "./messages";

/**
 * Resolves a host language tag to a supported locale.
 *
 * Telegram hands over `language_code` ("ru", "ru-RU"); the local adapter hands
 * over `navigator.language`. Anything we do not ship falls back to English.
 */
export function resolveLocale(languageTag: string | undefined): Locale {
  const primary = (languageTag ?? "").toLowerCase().split("-")[0];
  return LOCALES.find((locale) => locale === primary) ?? FALLBACK_LOCALE;
}
